import { render, staticRenderFns } from "./SvgTexts.vue?vue&type=template&id=3e572680"
import script from "./SvgTexts.vue?vue&type=script&lang=js"
export * from "./SvgTexts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports